/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ApiConstant from './api.constant';

export default {
  radarRasterSourceBase: ApiConstant.radarRasterSourceBase,
  scaleMultiplierForBorders: 4,
  scaleMultiplierForMetar: 50,
  scaleMultiplierForRouteIcaoID: 25,
  radarDataNotAvailable: 'Radar data not available',
  radarApiUrl: '/api/radar/radar',
  totalMinutesForRadar: 60,
  scaleMultiplierForZoomExtent: [4, 10, 80],
  scaleExtentMultiplier: {
    min: 0.8,
    max: 200,
  },
  mapMosNum: {
    web: 300,
    iPhone: 150,
    iPad: 200,
  },
  flightDotRadius: 14,
  flightDotMos: 6,
  metarSizePercentOfMos: 80,
  maxWidthBetweenRadarSlides: 60,
  radarSlidesCount: 6,
  flightDotiPhonePercent: 75,
  flightDotiPadPercent: 116,
  flightDotiPhoneMosPercent: 116,
  flightDotiPadMosPercent: 166,
  boundingBoxPaddingOffset: 50,
};
